
import { ICommonPensionInputs, SimplePensionFormOfPayment } from 'app/calcs/pensions/interfaces'
import * as moment from 'moment'

enum FandfFormOfPayment {
    lifeOnly = 1150,
    fiftyPercentJointAndSurvivor = 1152,
    seventyFivePercentJointAndSurvivor = 1153,
    fullJointAndSurvivor = 1154
  }

interface IFandfPensionInputs extends ICommonPensionInputs {
    beginPaymentsAge: moment.Duration
    formOfPayment: FandfFormOfPayment | SimplePensionFormOfPayment
    hireDate: moment.Moment
    basePay: number
    annualSalaryIncrease: number
}

export {
    IFandfPensionInputs,
    FandfFormOfPayment
}



// WEBPACK FOOTER //
// ./src/app/calcs/customers/fandf/interfaces/index.ts